import { BoundToggleButtonGroup } from "lib/@components/binding/bound-components.js"
import { Box, Stack, ToggleButton, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify.js"
import {
    SCHEDULE_LIBRARY_PREFERENCE_LABELS,
    SCHEDULE_LIBRARY_PREFERENCE_TOOLTIPS,
} from "routes/asset-register/plugins/asset-mapping/constants.js"

export function MappingScheduleTypePreference() {
    return (
        <BoundToggleButtonGroup
            size="small"
            fullWidth
            field="scheduleLibraryPreference"
            defaultValue="all"
            data-cy="mapping-rule-schedule-library-preference"
        >
            <ToggleButton value="all" data-cy="mapping-rule-schedule-library-all">
                <Tooltip title={SCHEDULE_LIBRARY_PREFERENCE_TOOLTIPS.all} arrow placement="top">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Iconify icon="mdi:file-document-box-multiple" />
                        <Box>{SCHEDULE_LIBRARY_PREFERENCE_LABELS.all}</Box>
                    </Stack>
                </Tooltip>
            </ToggleButton>
            <ToggleButton value="core_preferred" data-cy="mapping-rule-schedule-library-core_preferred">
                <Tooltip title={SCHEDULE_LIBRARY_PREFERENCE_TOOLTIPS.core_preferred} arrow placement="top">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Iconify icon="mdi:book-open-page-variant" />
                        <Box>{SCHEDULE_LIBRARY_PREFERENCE_LABELS.core_preferred}</Box>
                    </Stack>
                </Tooltip>
            </ToggleButton>
            <ToggleButton value="core_only" data-cy="mapping-rule-schedule-library-core_only">
                <Tooltip title={SCHEDULE_LIBRARY_PREFERENCE_TOOLTIPS.core_only} arrow placement="top">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Iconify icon="mdi:book-open-page-variant" />
                        <Box>{SCHEDULE_LIBRARY_PREFERENCE_LABELS.core_only}</Box>
                    </Stack>
                </Tooltip>
            </ToggleButton>
            <ToggleButton value="custom_preferred" data-cy="mapping-rule-schedule-library-custom_preferred">
                <Tooltip title={SCHEDULE_LIBRARY_PREFERENCE_TOOLTIPS.custom_preferred} arrow placement="top">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Iconify icon="ion:documents-outline" />
                        <Box>{SCHEDULE_LIBRARY_PREFERENCE_LABELS.custom_preferred}</Box>
                    </Stack>
                </Tooltip>
            </ToggleButton>
            <ToggleButton value="custom_only" data-cy="mapping-rule-schedule-library-custom_only">
                <Tooltip title={SCHEDULE_LIBRARY_PREFERENCE_TOOLTIPS.custom_only} arrow placement="top">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Iconify icon="ion:documents-outline" />
                        <Box>{SCHEDULE_LIBRARY_PREFERENCE_LABELS.custom_only}</Box>
                    </Stack>
                </Tooltip>
            </ToggleButton>
        </BoundToggleButtonGroup>
    )
}
